import styled, { css } from 'styled-components'

export const MainContentContainer = styled.div`
  position: relative;
  height: calc(100vh - 64px);
  overflow: hidden;
  overflow-y: auto;
  padding: 22px 20px;

  .no-result {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 23px;
    color: #FFFFFF;
    text-align: center;
  }
`;

export const CardList = styled.div`
  display: grid;
  justify-items: center;
  grid-template-columns: ${({ isMoreView }) => isMoreView ? `repeat(auto-fit, 200px)` : `repeat(auto-fit, 251px)`};
  grid-gap: 20px;
  gap: 20px;
  justify-content: space-evenly;
`;

export const ContentHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
`

export const HeaderActionList = styled.div`
  display: flex;
  align-items: center;
`

export const SelectWrapper = styled.div`
  margin: 0px 8px;
  #select-input {
    width: 155px;
    color: #191B24;
    background: #AAFF26;
    #list {
      background-color: #262835;
      > div {
        font-size: 14px;
        padding: 12px;
        &:hover {
          background-color: #222430;
        }
      }
    }
    > div:first-child {
      padding: 8px 12px;
      font-size: 18px;
      font-weight: bold;
      min-width: 100px;
      height: 44px;

      .select-arrow {
        color: #191B24;
      }
    }
  }
`

export const Option = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
`

export const SwitchWrapper = styled.div``
